import Decimal from 'decimal.js';
export const today = () => {const d=new Date();return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;};
export const money = value => new Intl.NumberFormat('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2}).format(Number(value || 0));
export const round = value => new Decimal(value || 0).toDecimalPlaces(2).toNumber();
export const clearClient = (form,cliente_id) => ({...form,cliente_id,pagos:[],saldo_id:'',otro_importe:''});
export function application(account,currency,amount,rate,equivalence) {
 if(!currency)throw new Error('Selecciona un banco para calcular el pago.');
 const received=new Decimal(amount || 0);
 if(!received.isFinite() || received.lte(0))throw new Error('El importe debe ser mayor a cero.');
 const factor=new Decimal(account.moneda===currency?1:equivalence || 0);
 if(!factor.isFinite() || factor.lte(0))throw new Error('Indica una equivalencia mayor a cero.');
 const paid=received.mul(factor).toDecimalPlaces(2);
 const balance=new Decimal(account.saldo || 0);
 if(paid.gt(balance))throw new Error('El importe aplicado supera el saldo pendiente.');
 return {paid:paid.toNumber(),remaining:balance.minus(paid).toDecimalPlaces(2).toNumber()};
}
// Round down in bank currency so settlement never exceeds the document balance.
export function settlementAmount(account,currency,equivalence) {
 if(!currency)throw new Error('Selecciona un banco para saldar.');
 const factor=new Decimal(account.moneda===currency?1:equivalence || 0);
 if(!factor.isFinite() || factor.lte(0))throw new Error('Indica una equivalencia mayor a cero.');
 return new Decimal(account.saldo || 0).div(factor).toDecimalPlaces(2,Decimal.ROUND_DOWN).toFixed(2);
}
export function validateCobro(form,fiscal) {
 const issues=[];
 if(!form.cliente_id)issues.push('Selecciona un cliente.');
 if(!form.fecha_pago)issues.push('Selecciona la fecha de pago.');
 if(!form.forma)issues.push('Selecciona una forma de pago.');
 if(!form.pagos.length && !(Number(form.otro_importe)>0))issues.push('Agrega una cuenta o un importe sin aplicar.');
 if(!Number.isFinite(Number(form.otro_importe || 0)) || Number(form.otro_importe || 0)<0)issues.push('El importe sin aplicar no puede ser negativo.');
 if(fiscal && form.forma==='99')issues.push('Selecciona una forma de pago distinta de 99 para el recibo electrónico.');
 if(fiscal && !form.pagos.length)issues.push('Aplica el recibo electrónico a una cuenta por cobrar.');
 if(fiscal && form.metodo!=='PPD')issues.push('El recibo electrónico requiere método PPD.');
 if(fiscal && Number(form.otro_importe)>0)issues.push('El recibo electrónico requiere aplicar el importe a documentos.');
 for(const p of form.pagos){
  if(!(Number(p.monto)>0))issues.push(`Folio ${p.folio}: captura el importe recibido.`);
  if(fiscal && !p.uuid)issues.push(`Folio ${p.folio}: requiere un CFDI vigente.`);
  if(fiscal && (!Number.isInteger(Number(p.parcialidad)) || Number(p.parcialidad)<Number(p.parcialidad_min || 1)))issues.push(`Folio ${p.folio}: revisa la parcialidad.`);
 }
 return issues;
}
